import React from 'react';
import { Label } from '../ui/label';
import { MessageSquare } from 'lucide-react';

export default function RequestsComments({ requests, onRequestsChange }) {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <div className="feature-badge teal mx-auto">
          <MessageSquare className="w-8 h-8" style={{ color: '#ffffff' }} />
        </div>
        <h2
          className="section-heading"
          style={{ textAlign: 'center', marginTop: '16px', marginBottom: '16px' }}
        >
          Your Requests & Comments
        </h2>
      </div>

      <div>
        <div className="space-y-4">
          <Label className="font-medium flex items-center gap-2 u-ink-800">
            
          </Label>
          <textarea
            value={requests}
            onChange={(e) => onRequestsChange(e.target.value)}
            className="brand-textarea requests-textarea"
            style={{ height: '260px' }}
            placeholder="Please let us know about:
• Areas that need extra attention
• Fragile items or special care instructions
• Pet information (if applicable)
• Preferred cleaning products or allergies
• Any other special requests 
​​​​"
          />
          
          <div className="text-xs u-ink-800">
            <p className="mb-1">💡 <strong>Helpful tip:</strong> The more details you provide, the better we can customize our service to your needs.</p>
            <p><strong>Common requests:</strong> Pet-friendly products, focus on high-traffic areas, extra sanitization, delicate surface care</p>
          </div>
        </div>
      </div>
    </div>
  );
}
